<!-- 质量管理 面板 -->
<template>
  <div>
    <div class="panel-wrapper">
      <BorderTitle>{{config.title}}</BorderTitle>
      <div class="panel-content">
        <div class="left">
          <template v-for="cfg in config.circleConfig">
            <CircleChart :key="cfg.id" v-bind="cfg" />
          </template>
        </div>
        <div class="right" ref="right">
          <LineChart :chartOption="config.chartOption||{}" :height="heightVal+'px'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BorderTitle from "../common/borderTitle";
import CircleChart from "./circle";
import LineChart from "./line";

export default {
  props: ["config"],
  data() {
    return {
      heightVal:''
    };
  },
  computed: {},
  created() {
    
  },
  mounted() {
    var height = this.$refs.right.offsetHeight;
    this.heightVal = height
    console.log(this.config.chartOption,"config.chartOption")
  },
  methods: {},
  components: {
    BorderTitle,
    CircleChart,
    LineChart,
  },
};
</script>

<style lang="scss" scoped="">
.panel-wrapper {
  background: #fff;
  padding: 20px;
  border: 1px solid #e1e1e1;
}
.panel-content {
  height: 290px;
  display: flex;
  .left {
    width: 160px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 30px;
  }
  .right {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
}
</style>